<template>
    <div>
        <v-btn small flat class="mr-2 text-capitalize" outline :color="color" @click.stop="$emit('abrirChatNoTabItensLotes')">
            <v-icon left size="15">fas fa-comment-alt</v-icon>
            <v-badge right color="red">
                <template v-slot:badge>
                    <span v-if="totalNaoLidas > 0">{{ totalNaoLidas }}</span>
                </template>
                Mensagens
            </v-badge>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'BotaoCentralMensagensChat',
    props: {
        color: {
            type: String,
            default: 'primary'
        },
        totalNaoLidas: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style scoped lang="stylus">

</style>